// extracted by mini-css-extract-plugin
export default {"divider":"MenuDivider_divider__1Csm3"};